<template>
  <div class="post article__content">
    <div class="post__wrapper">
      <help-links></help-links>
        <section>
          <div v-if="!$auth.check()" class="post-section promo">
            <div id="section_inner_0">
              <h2>
                Медицинский информационно-справочный ресурс
                {{ site.name }} содержит:
              </h2>
              <div class="home-news">
                <promotion></promotion>
              </div>
            </div>
          </div>
          <div class="post-section article-sections">
            <div
              id="section_inner_1"
              v-if="page && page.updates.length"
              :class="{ 'show-all': showUpdates }"
            >
              <h2>Последние обновления</h2>
              <div
                class="home-news updates"
                :class="{ hide: index > indexLimit - 1 }"
                :key="index"
                v-for="(article, index) in page.updates"
              >
                <div class="home-news__item">
                  <div class="home-header">
                    <span class="news-header__published">
                      {{ article.release_date | dateFormat }}
                    </span>
                    <span class="news-header__title">
                      {{ article.title }}
                    </span>
                  </div>
                  <div class="home-news__text" v-html="article.text"></div>
                  <div class="home-news__actions">
                    <span>Подробнее в статье </span>
                    <router-link
                      :to="{ path: article.link }"
                      class="home-news__link"
                    >
                      {{ article.link_text }}
                    </router-link>
                  </div>
                </div>
              </div>
              <a
                class="show-btn"
                v-if="page && page.updates.length > indexLimit"
                href="#"
                @click.prevent="showUpdates = !showUpdates"
              >
                {{
                  showUpdates
                    ? "Свернуть обновления"
                    : "Показать больше обновлений"
                }}
              </a>
            </div>
            <div id="section_inner_2" :class="{ 'show-all': showPosts }">
              <h2>Популярные материалы</h2>
              <div
                class="home-news"
                :key="index"
                :class="{ hide: index > indexLimit - 1 }"
                v-for="(article, index) in page.posts"
              >
                <div class="home-news__item">
                  <div class="home-header" v-html="article.title"></div>
                  <div class="user-news__actions">
                    <router-link
                      :to="{
                        name: 'post',
                        params: { code: article.base_id },
                      }"
                      class="user-news__link"
                    >
                      Перейти к статье
                    </router-link>
                  </div>
                </div>
              </div>
              <a
                class="show-btn"
                v-if="page && page.posts.length > indexLimit"
                href="#"
                @click.prevent="showPosts = !showPosts"
              >
                {{
                  showPosts
                    ? "Свернуть популярное"
                    : "Показать больше материалов"
                }}
              </a>
            </div>
            <div
              id="section_inner_3"
              v-if="page && page.reviews.length && !modeMz"
              :class="{ 'show-all': showReviews }"
            >
              <h2>Международные обзоры</h2>
              <div
                class="home-news updates"
                :class="{ hide: index > indexLimit - 1 }"
                :key="index"
                v-for="(article, index) in page.reviews"
              >
                <div class="home-news__item">
                  <div class="home-header">
                    <span class="news-header__published">
                      {{ article.release_date | dateFormat }}
                    </span>
                  </div>
                  <div class="home-news__text">
                    <span v-html="article.text"></span>
                    <router-link
                      :to="{ path: article.link }"
                      class="home-news__link"
                    >
                      Подробнее
                    </router-link>
                  </div>
                </div>
              </div>
              <a
                class="show-btn"
                v-if="page && page.reviews.length > indexLimit"
                href="#"
                @click.prevent="showReviews = !showReviews"
              >
                {{
                  showReviews ? "Свернуть обзоры" : "Показать больше обзоров"
                }}
              </a>
            </div>
          </div>
          <div v-if="$auth.check()" class="post-section promo">
            <div id="section_inner_0">
              <h2>
                Медицинский информационно-справочный ресурс
                {{ site.name }} содержит:
              </h2>
              <div class="home-news">
                <promotion></promotion>
              </div>
            </div>
          </div>
        </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HelpLinks from "@/_components/ui/HelpLinks";
import Promotion from "@/_components/blocks/Promotion";

export default {
  name: "HomeArticle",
  components: { Promotion, HelpLinks },
  data() {
    return {
      showUpdates: false,
      showPosts: false,
      showReviews: false,
      indexLimit: 3,
    };
  },
  computed: {
    ...mapGetters({
      page: "getHomePage",
      site: "getSite",
    }),
    modeMz() {
      return window.__env.settings.mode === "mz";
    },
    authState() {
      return this.$auth.check();
    },
  },
  watch: {
    authState() {
      this.resetHelperData();
      this.generateHelper();
    },
  },
  mounted() {
    this.resetHelperData();
    this.homePageRequest().then(() => {
      this.generateHelper();
    });
    this.swipeMenuShow();
  },
  methods: {
    ...mapActions({
      setHelperData: "setHelperData",
      resetHelperData: "resetHelperData",
      homePageRequest: "homePageRequest",
      swipeMenuShow : "swipeMenuShow"
    }),
    generateHelper() {
      const helperData = {
        title: "Главная",
        contents: [],
      };
      if (this.page.updates.length) {
        helperData.contents.push({
          anchor: "section_inner_1",
          title: "Последние обновления",
        });
      }
      helperData.contents.push({
        anchor: "section_inner_2",
        title: "Популярные материалы",
      });
      if (this.page.reviews.length && !this.modeMz) {
        helperData.contents.push({
          anchor: "section_inner_3",
          title: "Международные обзоры",
        });
      }
      if (this.$auth.check()) {
        helperData.contents.push({
          anchor: "section_inner_0",
          title: "О проекте",
        });
      } else {
        helperData.contents.unshift({
          anchor: "section_inner_0",
          title: "О проекте",
        });
      }
      this.setHelperData(helperData);
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-weight: 500;
  font-size: 1.8rem;
  margin-top: 12px;
  margin-bottom: 22px;
  line-height: 2rem;
}
.show-btn {
  display: block;
  position: relative;
  font-weight: 400;
}
.home-news {
  & .home-news__item {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    & .home-header {
      font-weight: 500;
    }
    & .home-news__text {
      margin: 8px 0;
    }
  }
}

.hide {
  display: none;
}
.show-all .hide {
  max-height: unset;
  display: block;
}
.post-section > div {
  margin-bottom: 32px;
}
</style>
